import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationUZ from './locales/uz.json';
import translationRU from './locales/ru.json';
import translationEN from './locales/en.json';

const resources = {
  uz: { translation: translationUZ },
  ru: { translation: translationRU },
  en: { translation: translationEN },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'uz', // Asosiy til — O'zbek
    fallbackLng: 'uz', // Fallback til — O'zbek
    debug: false,
    // 2.2 — escapeValue: true for XSS protection
    interpolation: {
      escapeValue: true,
    },
    detection: {
      order: ['localStorage', 'sessionStorage', 'navigator'],
      caches: ['localStorage', 'sessionStorage'],
    },
  });

export default i18n;
